import { useMemo } from 'react';

// ---- Module-scope pure helpers (stable, no deps) ----
const durationOfSkills = (m) =>
  (m.skills?.filter((s) => s.name.trim()).length || 0) * 5;

const durationOfQuestions = (m) =>
  (m.questions || []).reduce((sum, q) => sum + (Number(q.time) || 0), 0);

const durationOfExercise = (m) => Number(m.duration) || 0;
const durationOfResume = (m) => Number(m.duration) || 15;
const durationOfLanguage = (m) => Number(m.duration) || 10;

const DURATION_FNS = {
  'skill-conversations': durationOfSkills,
  'custom-questions': durationOfQuestions,
  'exercise': durationOfExercise,
  'resume-conversation': durationOfResume,
  'language-assessment': durationOfLanguage,
};

const INTRO_BASE = 3;

export function computeDuration(flow) {
  return flow.reduce((total, m) => {
    const fn = DURATION_FNS[m.type];
    return fn ? total + fn(m) : total;
  }, INTRO_BASE);
}

export function classifyLength(totalDuration) {
  if (totalDuration < 10) {
    return { text: 'Interview length is too short', color: 'bg-[#FDECEC] text-[#C23B3B]' };
  }
  if (totalDuration > 60) {
    return { text: 'Interview length is too long', color: 'bg-[#FDECEC] text-[#C23B3B]' };
  }
  return { text: 'Interview length is perfect', color: 'bg-[#E8F7EE] text-[#1F8A4E]' };
}

export function useInterviewDuration(flow) {
  // `computeDuration` is a module-scope constant (never changes); omitting
  // it from deps is the canonical pattern.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => computeDuration(flow), [flow]);
}

export function useLengthLabel(totalDuration) {
  // `classifyLength` is a module-scope constant – intentionally omitted.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => classifyLength(totalDuration), [totalDuration]);
}
